var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5219 21.9973C32.7607 18.3936 34.8983 10.4121 31.2964 4.17024L33.3223 3C37.5702 10.3613 35.0493 19.7742 27.6916 24.0242L26.5219 21.9973Z",
    fill: "#008DBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0649 0.00182034C33.9247 0.00182021 36.2431 2.32131 36.2431 5.18255C36.2431 8.04379 33.9247 10.3633 31.0649 10.3633C28.2051 10.3633 25.8867 8.04379 25.8867 5.18255C25.8867 2.32131 28.2051 0.00182046 31.0649 0.00182034Z",
    fill: "#008DBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6054 43.2305C7.92439 43.2305 0.0683815 35.4129 -7.64391e-07 25.7432C2.65281 27.1057 5.57195 28.0069 8.65642 28.3439C10.1039 32.0524 13.7848 34.6875 18.097 34.6875C23.6737 34.6875 28.1945 30.2805 28.1945 24.8441C28.1945 24.3878 28.1626 23.9388 28.101 23.499C30.3798 21.9183 32.0997 19.7947 33.1862 17.4066C34.4793 19.8579 35.2112 22.6514 35.2112 25.616C35.2112 35.3442 27.3288 43.2305 17.6054 43.2305ZM32.183 15.7359C29.0164 11.0682 23.6689 8.0015 17.6054 8.0015C10.1339 8.0015 3.74938 12.6579 1.19287 19.2284C3.35513 20.612 5.8063 21.5685 8.43298 21.9822C9.69048 17.9416 13.5414 15.0007 18.097 15.0007C22.602 15.0007 26.418 17.8767 27.7182 21.848C29.8161 20.2431 31.3318 18.1033 32.183 15.7359Z",
    fill: "#008DBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bce122cd4d613929d14939d1639698ec.svg";
export { ForwardRef as ReactComponent };